import { render, staticRenderFns } from "./TerminalCommand.vue?vue&type=template&id=10831133&scoped=true&"
import script from "./TerminalCommand.vue?vue&type=script&lang=js&"
export * from "./TerminalCommand.vue?vue&type=script&lang=js&"
import style0 from "./TerminalCommand.vue?vue&type=style&index=0&id=10831133&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10831133",
  null
  
)

export default component.exports